var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGadgetGift = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.229 482.229",
    style: {
      enableBackground: "new 0 0 482.229 482.229"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.316,75.172l257.166-1.092V248.26l-141.64,0.6v31.338h142.732 c17.018,0,30.854-13.844,30.854-30.856V74.08c0-17.011-13.837-30.856-30.854-30.856H166.316c-17.018,0-30.855,13.845-30.855,30.856 v54.854h31.198L166.316,75.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.152,287.593h-190.31v36.493h173.977c14.585,0,26.41-11.824,26.41-26.417 C482.229,292.108,477.721,287.593,472.152,287.593z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.672,152.894H112.484c-18.313,0-33.21,14.897-33.21,33.211v46.173h18.203 c4.851,0,9.438,0.999,13.743,2.581v-48.754c0-0.694,0.56-1.264,1.264-1.264h112.188c0.703,0,1.264,0.569,1.264,1.264v155.717 h-88.492v45.159h87.229c18.314,0,33.211-14.897,33.211-33.211V186.105C257.883,167.792,242.986,152.894,224.672,152.894z  M168.578,372.382c-4.039,0-7.456-2.379-9.188-5.757c-0.733-1.426-1.248-2.979-1.248-4.686c0-5.765,4.681-10.435,10.436-10.435 c5.757,0,10.436,4.67,10.436,10.435c0,1.708-0.514,3.26-1.247,4.686C176.035,370.003,172.618,372.382,168.578,372.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.478,252.245H19.998C8.969,252.245,0,261.222,0,272.25v146.756 c0,11.03,8.969,19.999,19.998,19.999h77.479c11.029,0,19.999-8.969,19.999-19.999V272.25 C117.477,261.222,108.507,252.245,97.478,252.245z M23.96,276.205h69.556v126.859H23.96V276.205z M58.745,429.287 c-2.199,0-4.164-0.89-5.663-2.262c-1.699-1.544-2.792-3.712-2.792-6.185c0-4.665,3.776-8.439,8.455-8.439 c4.648,0,8.425,3.774,8.425,8.439c0,2.473-1.093,4.64-2.778,6.185C62.895,428.397,60.93,429.287,58.745,429.287z"
  }))));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGadgetGift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gadget-gift.d76b2a32.svg";
export { ForwardRef as ReactComponent };